<div id="overlay" *ngIf="estAffiche" (click)="close()" class="overlay"></div>
<div class="popup-container app-habitation" *ngIf="estAffiche" id="popup">
  <app-popup-email-error *ngIf="name === 'email-error'"></app-popup-email-error>
  <app-popup-capacite-error *ngIf="name === 'capacite-error'" [mode]="params"></app-popup-capacite-error>
  <app-popup-propriete-error *ngIf="name === 'propriete-error'" [mode]="params"></app-popup-propriete-error>
  <app-popup-photo-error *ngIf="name === 'photo-error'" [errorType]="params"></app-popup-photo-error>
</div>
